const BASE_ACTION = "POLLING/";
export const FETCH_POLLING_SUCCESS = `${BASE_ACTION}FETCH_POLLING_SUCCESS`;
export const FETCH_POLLING_FAIL = `${BASE_ACTION}FETCH_POLLING_FAIL`;
export const FETCH_POLLING_START = `${BASE_ACTION}FETCH_POLLING_START`;
export const STOP_POLLING = `${BASE_ACTION}STOP_POLLING`;
export const UPDATE_ALARM = `${BASE_ACTION}UPDATE_ALARM`;
export const RESET_POLLNG_STATE = `${BASE_ACTION}RESET_POLLNG_STATE`;
export const UPDATE_ALL_ALARMS = `${BASE_ACTION}UPDATE_ALL_ALARMS`;
export const NEW_ACTIVE_ALARM = `${BASE_ACTION}NEW_ACTIVE_ALARM`;
export const INACTIVE_ALARMS = `${BASE_ACTION}INACTIVE_ALARMS`;
